enum EventVisibility  {
  Public = 1,
  Private = 2,
  RequiredTicket = 3,
}
export default Object.freeze(EventVisibility);
